// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T7He","type":"styles_type__2giIZ","choices":"styles_choices__3qPtO"};